namespace Nobox.Administration {
    export interface IntegrationRow {
        Id?: number;
        TenantId?: number;
        Provider?: string;
        AppName?: string;
        AppEndpoint?: string;
        AppId?: string;
        AppClientId?: string;
        AppSecret?: string;
        AppOptions?: string;
        Notes?: string;
        In?: string;
        Up?: string;
    }

    export namespace IntegrationRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Provider';
        export const localTextPrefix = 'Administration.Integration';
        export const lookupKey = 'Lookup.Integration';

        export function getLookup(): Q.Lookup<IntegrationRow> {
            return Q.getLookup<IntegrationRow>('Lookup.Integration');
        }
        export const deletePermission = 'Tenants';
        export const insertPermission = 'Tenants';
        export const readPermission = '?';
        export const updatePermission = 'Tenants';

        export declare const enum Fields {
            Id = "Id",
            TenantId = "TenantId",
            Provider = "Provider",
            AppName = "AppName",
            AppEndpoint = "AppEndpoint",
            AppId = "AppId",
            AppClientId = "AppClientId",
            AppSecret = "AppSecret",
            AppOptions = "AppOptions",
            Notes = "Notes",
            In = "In",
            Up = "Up"
        }
    }
}
